import React, { useEffect } from 'react'
import { useI18n } from '@ggs/i18n'
import { useModal } from '@ggs/ui/common'
import { get, noop } from 'lodash'
import { Box } from '@mui/material'
import { SaveProjectResourceForm } from '../../index'
import { getViewedPageParams } from '@ggs/utils'
import {
  cleanEntityOperation,
  useDispatch
} from '@ggs/store'
import { useUrlParams } from '@ggs/hooks'

/**
 * @typedef {import('../../../definitions').MimeeqCustomProduct} MimeeqCustomProduct
 */

/**
 * @typedef {Object} AddProjectCustomProductActionProps
 * @property {string} resourceType
 * @property {string} resourceId
 * @property {function} updateClickedWishlistState
 * @property {boolean} clickedWishlist
 */

/**
 * Add project custom mimeeq product modal.
 * @param {AddProjectCustomProductActionProps} props
 * @return {JSX.Element}
 */
export const AddProjectCustomProductModal = ({
  resourceType,
  resourceId,
  updateClickedWishlistState,
  clickedWishlist
}) => {
  const { t } = useI18n()
  const dispatch = useDispatch()
  const { removeQueryParam } = useUrlParams()
  const { modal, triggerModal } = useModal({
    className: 'save-project-dialog',
    scroll: 'body',
    title: (
      <Box className="save-project-dialog__title">
        <h2>{t('Save Custom Product to Project')}</h2>
      </Box>
    ),
    content: (props) => {
      const closeModal = get(props, 'closeModal', noop)
      return (
        <SaveProjectResourceForm
          resourceType={resourceType}
          resourceId={resourceId}
          closeModal={closeModal}
        />
      )
    },
  })


  // Auto-open save custom product modal.
  useEffect(() => {
    if (clickedWishlist === true) {
      triggerModal()
      if (typeof updateClickedWishlistState === 'function') {
        updateClickedWishlistState() // Execute the callback function
      }

      const pageParams = getViewedPageParams()
      const shortCodeQueryValue = get(pageParams, 'short_code', null)
      if (shortCodeQueryValue) {
        // Remove only the "short_code={code}" parameter from the URL
        const currentUrl = window?.location?.pathname + window?.location?.search
        const urlWithoutShortCodeArg = removeQueryParam(currentUrl, 'short_code', shortCodeQueryValue)
        window.history.replaceState({}, document.title, urlWithoutShortCodeArg)
        // Clean entity from redux store.
        dispatch(cleanEntityOperation(`custom_product_${shortCodeQueryValue}`))
      }
    }
  }, [resourceId, clickedWishlist])

  return <>{modal}</>
}
